import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  NgZone,
  signal,
} from "@angular/core";

import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import gsap from "gsap";

import { BuildingConfig, BuildingType } from "../../data";
import { AppAvailability } from "@app/core";

@Component({
    selector: "app-building",
    templateUrl: "./building.component.html",
    styleUrls: ["./building.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BuildingComponent implements AfterViewInit {

  availableApps = input<AppAvailability>();
  sanitizer = inject(DomSanitizer);
  safeFilterUrl: SafeUrl;
  defaultConfig: BuildingConfig = {
    buildingType: BuildingType.Warehouse,
    initialHeight: 200,
    width: 400, 
    finalHeight: 200,
    heightOffset: 0,
    windowMargin: 0,
    animationDelay: 1,
    showBase: false,
  };
  config = input<BuildingConfig>(this.defaultConfig);
  rightWindowRows = input<number>();
  buildingType = BuildingType;

  private zone = inject(NgZone);
  height = signal<number>(this.config()?.initialHeight);
  heightOffset = computed(() => this.config()?.heightOffset);


  ngAfterViewInit(): void {
    this.animate();
  }


  public isAvailable = computed(() => {
    const app = this.availableApps()?.[this.config().key];
    return app && app();
  });

  animate() {
    const obj = { x: this.height() };
    gsap.to(obj, {
      x: this.config().finalHeight,
      duration: 1,
      delay: this.config().animationDelay,
      ease: "power2.inOut",
      onUpdate: () => {
        this.zone.run(() => {
          this.height.set(obj.x);
        });
      },
    });
  }
}
